export default __webpack_public_path__ + "static/pro@768_2x-3e6f7a766a45ebe4964185352bfb4047.webp";